import { Icon } from 'shared/iconpack'
import { displayDate } from 'shared/libs/dayjs/helpers'
import { apiTimeFormatHourMinute } from 'shared/libs/dayjs/model'

import { useNavigate } from 'react-router-dom'

import { OrderData } from 'modules/Orders/types'
import NewOrderBadge from 'modules/Orders/ui/NewOrderBadge'

import { Button } from 'shared/ui/Button'
import { Card } from 'shared/ui/Card/Card'
import { Circle } from 'shared/ui/Circle'

import { palette } from 'shared/config/styles/palette'

import './OrderColumnItem.css'

interface Props {
  orderItem: OrderData
}

const OrderColumnItem = ({ orderItem }: Props) => {
  const navigate = useNavigate()

  const {
    id,
    order_number,
    total_sum,
    delivery_address,
    delivery_way,
    delivery_type,
    phone_number,
    branch,
    company_name,
    acceptance_date,
    seen,
  } = orderItem

  const handleClickCard = () => {
    navigate(`${id}`)
  }

  return (
    <Card
      className="customCard h-full pt-[14px] pb-[10px] bg-white border border-light_gray_3 rounded-[16px]"
      hoverable
      onClick={handleClickCard}
    >
      <div className="pb-[11px] px-[12px] border-b border-light_gray_3">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            {!seen && <NewOrderBadge />}
            <div className="flex gap-1 text-light_gray_4 text-[13px] leading-[16px]">
              <span>{order_number}</span>
              <span>•</span>
              <span>
                {displayDate(acceptance_date, apiTimeFormatHourMinute)}
              </span>
            </div>
          </div>
          <Button className="flex items-center gap-[1.5px] p-0 h-fit border-none">
            <Circle
              size={3}
              sameWrapperSize={true}
              color={palette.light_gray_4}
            />
            <Circle
              size={3}
              sameWrapperSize={true}
              color={palette.light_gray_4}
            />
            <Circle
              size={3}
              sameWrapperSize={true}
              color={palette.light_gray_4}
            />
          </Button>
        </div>
        <div className="flex flex-col gap-[8px] mt-[14px]">
          <strong className="font-semibold break-all text-[15px] leading-[22px] text-dark">
            {total_sum} сом
          </strong>
          <ul className="flex flex-col gap-[4px]">
            <li className="flex justify-between gap-[5px]">
              <span className="text-light_gray_4 text-[11px] leading-[14px]">
                Клиент:
              </span>
              <span className="text-dark text-end break-all text-[11px] leading-[14px]">
                {phone_number}
              </span>
            </li>
            {delivery_way === 'COURIER' && (
              <li className="flex justify-between gap-[5px]">
                <span className="whitespace-nowrap text-light_gray_4 text-[11px] leading-[14px]">
                  Адрес доставки:
                </span>
                <span className="text-dark text-end text-ellipsis line-clamp-3 break-words text-[11px] leading-[14px]">
                  {delivery_address || 'Отсутствует'}
                </span>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="flex items-center justify-between flex-wrap gap-[5px] px-[12px] pt-[6px] text-light_gray_4">
        <div className="flex items-center gap-[2px]">
          <Icon
            className="min-w-[16px] min-h-[16px]"
            name="flag"
            size={16}
            color={palette.dark_orange_1}
          />
          <span className="p-[4px] leading-[16px] text-[13px]">{branch}</span>
        </div>
        <div className="flex">
          <span className="leading-[16px] text-[13px] break-all">
            {delivery_way === 'COURIER'
              ? `Доставка ${delivery_type === 'YANDEX' ? delivery_type : delivery_type ? company_name : ''}`
              : 'Самовывоз'}
          </span>
        </div>
      </div>
    </Card>
  )
}

export default OrderColumnItem
